var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsappinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.73 44.73"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".whatsapp_inline_svg__cls-2{fill:#fff;fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp_inline_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whatsapp_inline_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whatsapp_inline_svg__Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "whatsapp_inline_svg__Elipse_3",
    "data-name": "Elipse 3",
    cx: 22.36,
    cy: 22.36,
    r: 22.36,
    fill: "#00993b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "whatsapp_inline_svg__cls-2",
    d: "M32.27 12.4a13.92 13.92 0 00-21.91 16.8l-2 7.21 7.38-1.93a14 14 0 006.66 1.69 13.94 13.94 0 0013.94-13.92 13.79 13.79 0 00-4.07-9.85zm-9.85 21.42a11.56 11.56 0 01-5.89-1.61L16.1 32l-4.38 1.1 1.17-4.27-.27-.43a11.57 11.57 0 119.8 5.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "whatsapp_inline_svg__cls-2",
    d: "M28.77 25.15c-.35-.17-2.06-1-2.38-1.13s-.55-.17-.78.17-.9 1.14-1.1 1.37-.41.26-.76.09A9.81 9.81 0 0121 23.92a10.21 10.21 0 01-2-2.41.51.51 0 01.15-.71c.16-.16.35-.41.53-.61a2.26 2.26 0 00.34-.58A.62.62 0 0020 19c-.08-.18-.78-1.89-1.07-2.58s-.57-.59-.78-.6h-.67a1.27 1.27 0 00-.93.43 3.94 3.94 0 00-1.21 2.9 6.68 6.68 0 001.42 3.6A15.41 15.41 0 0022.71 28c.83.35 1.48.57 2 .73a4.84 4.84 0 002.19.14 3.6 3.6 0 002.35-1.66 3 3 0 00.21-1.65c-.11-.15-.34-.23-.69-.41z"
  }))))));
}

export default SvgWhatsappinline;